var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 21,
    viewBox: "0 0 40 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6359 1.27222C19.4042 0.555701 20.5958 0.5557 21.3641 1.27221L38.804 17.5374C40.1317 18.7757 39.2555 21 37.4399 21L2.56012 21C0.744522 21 -0.131733 18.7757 1.19603 17.5374L18.6359 1.27222Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPolygon);
export default __webpack_public_path__ + "static/media/black-polygon.da27d32339a684d2caefd80bf5521907.svg";
export { ForwardRef as ReactComponent };